<div *ngIf="objectType=='booking' && object.isBooking" class="bloc">
    <div class="line">

        <div class="label">
            N° Dossier
        </div>
        <div class="value">
            {{ object.numreservation }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Modèle de bateau
        </div>
        <div class="value">
            {{ object.modele }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Bateau
        </div>
        <div class="value">
            {{ object.nombateau }} ({{ object.numbateau }})
        </div>
    </div>
    <div class="line">
        <div class="label">
            Client
        </div>
        <div class="value">
            {{ object.nomclient }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Periode
        </div>
        <div class="value">
            {{ 'date.from.label' | translate }}
            {{ object.startDate | date: 'shortDate':undefined:locale }}
            {{ 'date.to.label' | translate }}
            {{ object.endDate | date: 'shortDate':undefined:locale }}
        </div>
    </div>
</div>
<div *ngIf="objectType=='booking' && object.isOption" class="bloc">
    <div class="line">

        <div class="label">
            N° Dossier
        </div>
        <div class="value">
            {{ object.numreservation }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Modèle de bateau
        </div>
        <div class="value">
            {{ object.modele }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Bateau
        </div>
        <div class="value">
            {{ object.nombateau }} ({{ object.numbateau }})
        </div>
    </div>
    <div class="line">
        <div class="label">
            Client
        </div>
        <div class="value">
            {{ object.nomclient }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Periode
        </div>
        <div class="value">
            {{ 'date.from.label' | translate }}
            {{ object.startDate | date: 'shortDate':undefined:locale }}
            {{ 'date.to.label' | translate }}
            {{ object.endDate | date: 'shortDate':undefined:locale }}
        </div>
    </div>
</div>
<div *ngIf="objectType=='booking' && object.isDevis" class="bloc">
    <div class="line">

        <div class="label">
            N° Dossier
        </div>
        <div class="value">
            {{ object.numreservation }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Modèle de bateau
        </div>
        <div class="value">
            {{ object.modele }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Bateau
        </div>
        <div class="value">
            {{ object.nombateau }} ({{ object.numbateau }})
        </div>
    </div>
    <div class="line">
        <div class="label">
            Client
        </div>
        <div class="value">
            {{ object.nomclient }}
        </div>
    </div>
    <div class="line">
        <div class="label">
            Periode
        </div>
        <div class="value">
            {{ 'date.from.label' | translate }}
            {{ object.startDate | date: 'shortDate':undefined:locale }}
            {{ 'date.to.label' | translate }}
            {{ object.endDate | date: 'shortDate':undefined:locale }}
        </div>
    </div>
</div>